





import { Component, Prop, Vue } from 'vue-property-decorator';
import { Issue } from '@/interfaces/Issue';
import IssueRowCard from '@/components/Issues/IssueRowCard.vue';
import { Cutoverplan } from '@/interfaces/Cutoverplan';

@Component({
  components: { IssueRowCard }
})
export default class IssueRow extends Vue {
  @Prop()
  issue!: Issue;

  @Prop()
  cutoverplan!: Cutoverplan;
}
